import { QRCodeFormSchema } from '@app/domain/qr-code/api/qr-code.form.schema.api';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { QRCodeSocialNetworks } from '../../QRCodeSocialNetworks';
import { QRCodeDesignSection } from '../../QRCodeDesignSection';
import { TranslationKey } from '@app/locales/defaultTranslation';
import { QRCodeStepper } from '../../QRCodeStepper';
import { QRCodeLinksEditor } from '../../QRCodeLinksEditor';
import { QRCodeHeaderEditor } from '../../QRCodeHeaderEditor';

/*
TODO show form errors if any
With current behavior, if form invalid and related property not rendered
user will not see this error anyhow and will be blocked to navigate to other form steps.
Need a universal solution for this.
Maybe errors summary or at least snackbar.
But what if component rendered and focused on error - snackbar will be redundant in this case.
Maybe show snackbar only for null error types - which mean property was not buond to an input yet?
But also value may be not null and still invalid and still not linked to currently visible input
because input may be conditionally rendered in other form steps, for example.
*/

const multilinkSteps: TranslationKey[] = ['qr.multilinkInput.headerLinksTab', 'qr.stepInput.designTab'];

export const QRCodeMultilink: React.FC<{
  forWidgetMode?: boolean;
  disabledEditInput?: boolean;
}> = ({ forWidgetMode, disabledEditInput }) => {
  const [activeStep, setActiveStep] = useState(0);
  const { trigger } = useFormContext<QRCodeFormSchema>();

  return (
    <div className="flex flex-col gap-4">
      <QRCodeStepper
        steps={multilinkSteps}
        activeStep={activeStep}
        setActiveStep={async (nextStep) => {
          const canSetNextStep = await trigger('multilink', { shouldFocus: true });
          if (canSetNextStep) {
            setActiveStep(() => nextStep);
          }
        }}
      />

      {!activeStep ? (
        <>
          <QRCodeHeaderEditor prefix="multilink" forWidgetMode={forWidgetMode} disabledEditInput={disabledEditInput} />
          <QRCodeLinksEditor
            forWidgetMode={forWidgetMode}
            disabledEditInput={disabledEditInput}
            linksFormPath="multilink.customLinks"
          />
          <QRCodeSocialNetworks formPath="multilink.socialLinks" disabledEditInput={disabledEditInput} />
        </>
      ) : (
        <QRCodeDesignSection prefix="multilink" />
      )}
    </div>
  );
};
